(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/views/best-rows-list.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/views/best-rows-list.js'); 
'use strict';

svs.sport.best_rows.views.BestRowsList = Marionette.CollectionView.extend({
  childView: svs.sport.best_rows.views.BestRowsListItem,

  log: new svs.core.log.Logger('svs.sport.best_rows.views.BestRowsList'),

  className: 'best-rows-list',

  collectionEvents: {
    change: 'render',
    reset: 'render'
  }
});

 })(window);